import { SOURCE_TYPE_ENHANCED_SEARCH_BOX } from "@catchoftheday/analytics";
export var mapSearchBarProducts = function mapSearchBarProducts(products) {
  return products.map(function (item) {
    if (item.data) {
      return {
        id: item.id,
        title: item.value,
        brand: null,
        url: "".concat(item.data.url, "?st=").concat(SOURCE_TYPE_ENHANCED_SEARCH_BOX),
        priceTag: {
          priceLabel: {
            price: {
              amount: item.data.price * 100
            }
          },
          clubExclusive: false,
          enabled: true
        },
        assets: {
          hero: {
            url: item.data.image_url,
            altText: item.value
          }
        }
      };
    }
  }).filter(Boolean);
};